import type { TFunction } from "i18next";
import {
  AccordionProps,
  LINE_BREAK,
} from "../../components/shared/Accordion/Accordions";
import { GetTypographyContent } from "../../components/shared/Typography/Typography";
import AneuploidyVideoEmbed from "../../components/shared/Video/AneuploidyVideoEmbed";
import RhDVideoEmbed from "../../components/shared/Video/RhDVideoEmbed";
import { HelpFAQAnswerWrapper } from "./Help.styles";

const paragraph = (content: string) =>
  GetTypographyContent({
    content,
    size: "medium",
  });

export const aneuploidyHelpAccordions = (
  reqID: string,
  t: TFunction<"translation">,
): AccordionProps[] => [
  {
    title: t("help.aneuploidy.testFor.title"),
    content: (
      <HelpFAQAnswerWrapper>
        <div style={{ display: "grid" }}>
          <AneuploidyVideoEmbed
            reqID={reqID}
            videoLocation="aneuploidy_learn_more"
          />
        </div>
        {LINE_BREAK}
        {LINE_BREAK}
        {paragraph(t("help.aneuploidy.testFor.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "aneuploidyTestFor",
  },
  {
    title: t("help.aneuploidy.resultTypes.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {paragraph(t("help.aneuploidy.resultTypes.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "aneuploidyTypeResults",
  },
  {
    title: t("help.aneuploidy.familyHistory.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {paragraph(t("help.aneuploidy.familyHistory.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "downSyndromeHistory",
    padding: "0 0 20px 0",
  },
  {
    title: t("help.aneuploidy.eligibility.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {paragraph(t("help.aneuploidy.eligibility.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "aneuploidyEligibility",
  },
  {
    title: t("help.aneuploidy.timing.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {paragraph(t("help.aneuploidy.timing.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "aneuploidyResultTime",
  },
  {
    title: t("help.aneuploidy.fetalSexAccuracy.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {paragraph(t("help.aneuploidy.fetalSexAccuracy.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "fetalSexAccuracy",
  },
  {
    title: t("help.aneuploidy.rhd.title"),
    content: (
      <HelpFAQAnswerWrapper>
        <div style={{ display: "grid" }}>
          <RhDVideoEmbed reqID={reqID} videoLocation="rhd_learn_more" />
        </div>
        {LINE_BREAK}
        {LINE_BREAK}
        {paragraph(t("help.aneuploidy.rhd.body"))}
      </HelpFAQAnswerWrapper>
    ),
    key: "rhdResults",
  },
];
